<template>
  <div
    class="monthly-due d-flex"
    data-cy="monthly-due"
  >
    <div
      class="h2"
      data-cy="label"
    >
      Cotisation mensuelle :
    </div>
    <div
      class="h2 primary-color ps-2"
      data-cy="value"
    >
      {{ value }}
    </div>
  </div>
</template>

<script>
/**
 * Cotisation Mensuelle
 * Un simple composant pour afficher une cotisation mensuelle
 */
export default {
  name: 'CotisationMensuelle',
  props: {
    value: {
      type: String,
      required: true,
    }
  },
}
</script>

